const formatUserExtended = (t, user, userEvent) => {
  if (!t) {
    return {}
  }

  const extended = Object.entries({
    ...(user?.extended || {}),
    ...(userEvent?.extended || {}),
  }).reduce((prev, [key, value]) => {
    // Sur un champ à options, une valeur en CHAÎNE est la CLÉ de l'option (valeurs héritées du
    // widget WordPress, du BO avant correctif, ou d'un import) : on affiche son libellé.
    // Sur un champ texte libre aucune traduction ne correspond -> valeur rendue telle quelle.
    // `t` est plat (clé -> libellé, unique par domaine), donc non scopé au champ : une réponse
    // libre qui vaudrait exactement la clé d'une autre traduction serait traduite. Cas résiduel.
    if (typeof value === 'string') {
      return { ...prev, [key]: { label: t[key], value: t[value] || value } }
    }

    if (value === true || value === false) {
      return { ...prev, [key]: { label: t[key], value: value ? 'Oui' : 'Non' } }
    }

    if (value !== null && typeof value === 'object') {
      const values = Object.entries(value)
        .filter(([, v]) => v)
        .map(([k]) => t[k])
        .join(', ')
      return { ...prev, [key]: { label: t[key], value: values } }
    }

    return prev
  }, {})

  return extended
}

export default formatUserExtended
